import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern kit — a chest of drawers (0.9 x 0.45 x 0.9): oak body, three walnut
// drawer fronts with steel handles, walnut top, short black legs.
const OAK = "#c8975a";
const WALNUT = "#7a5a3a";
const BLACK = "#2e2e30";
const STEEL = "#aab2b8";

export const dresser = defineModel({
  id: "dresser",
  batchId: "modern",
  name: "Dresser",
  tags: ["modern", "interior", "furniture", "bedroom", "storage"],
  summary: "An oak chest of drawers with three drawers.",
  tiles: { w: 1, h: 1 },
  footprint: 0.8,
  parts(): Part[] {
    return [
      // short legs
      { geometry: new THREE.BoxGeometry(0.04, 0.12, 0.04), color: BLACK, position: [-0.4, 0.06, -0.18] },
      { geometry: new THREE.BoxGeometry(0.04, 0.12, 0.04), color: BLACK, position: [0.4, 0.06, -0.18] },
      { geometry: new THREE.BoxGeometry(0.04, 0.12, 0.04), color: BLACK, position: [-0.4, 0.06, 0.18] },
      { geometry: new THREE.BoxGeometry(0.04, 0.12, 0.04), color: BLACK, position: [0.4, 0.06, 0.18] },
      // body
      { geometry: new THREE.BoxGeometry(0.9, 0.74, 0.45), color: OAK, position: [0, 0.49, 0] },
      // top
      { geometry: new THREE.BoxGeometry(0.94, 0.04, 0.49), color: WALNUT, position: [0, 0.88, 0] },
      // three drawer fronts
      { geometry: new THREE.BoxGeometry(0.78, 0.2, 0.02), color: WALNUT, position: [0, 0.24, 0.235] },
      { geometry: new THREE.BoxGeometry(0.78, 0.2, 0.02), color: WALNUT, position: [0, 0.49, 0.235] },
      { geometry: new THREE.BoxGeometry(0.78, 0.2, 0.02), color: WALNUT, position: [0, 0.74, 0.235] },
      // handles
      { geometry: new THREE.BoxGeometry(0.2, 0.025, 0.02), color: STEEL, position: [0, 0.24, 0.25] },
      { geometry: new THREE.BoxGeometry(0.2, 0.025, 0.02), color: STEEL, position: [0, 0.49, 0.25] },
      { geometry: new THREE.BoxGeometry(0.2, 0.025, 0.02), color: STEEL, position: [0, 0.74, 0.25] },
    ];
  },
  animations: [],
});
